var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.isShowNav)?_c('i-nav-bar',{attrs:{"iTitle":_vm.$route.meta.name}}):_vm._e(),_c('router-view',{staticClass:"view_main"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }